import React, { useEffect } from 'react'
import { useRef } from 'react'
import styles from './Contact.module.scss'
import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import animationStyles from 'components/common/Animation/Animation.module.scss'
import useElementVisible from 'components/common/Animation/useElementVisible'

const Contact: React.FC = () => {
  const animeRef = useRef<HTMLDivElement>(null)
  const isVisible = useElementVisible(animeRef, 0.1)

  //useHubSpotGenerate('na1', '9395227', '88d227a9-62ad-4bb3-a335-aac16baa41a0', '#hbspt')
  useHubSpotGenerate('na1', '9395227', '7cf23a21-ccad-498a-8086-072af6acdbe7', '#hbspt')
  useEffect(() => {
    const intervalId = setInterval(() => {
      const selectElements = document.querySelectorAll('select')
      if (selectElements.length > 0) {
        clearInterval(intervalId)
        selectElements.forEach((selectElement) => {
          selectElement.style.color = '#666666' // 初期色を設定
          selectElement.addEventListener('change', () => {
            // 選択状態によって色を変更
            selectElement.style.color = selectElement.selectedIndex === 0 ? '#666666' : '#222222'
          })
        })
      }
    }, 100)

    return () => {
      clearInterval(intervalId)
    }
  }, [])

  return (
    <section
      className={`${styles.contents} ${animationStyles.fade} ${isVisible ? animationStyles.fadeOn : ''}`}
      ref={animeRef}
    >
      <div className={styles.content}>
        <div className={styles.title_group}>
          <h1 className={styles.title}>お問い合わせ</h1>
          <p className={styles.text}>
            アプリやシステム開発、UX/UI改善など、お客さまのビジネスを成功に導いたサポート実績が多数ございます。お気軽にお問い合わせください。
          </p>
        </div>
        <div id="hbspt" className={styles.contactForm}></div>
      </div>
    </section>
  )
}

export default Contact
